<template>
  <base-event-log-item
    icon="list_alt"
    :icon-color="iconColor"
    :researcher="referenceEventLog.eventBy"
    :date="referenceEventLog.createdAt"
    :bottom-node="bottomNode"
    :color="color"
  >
    <div class="text-overflow-ellipsis">
      <span class="font-weight-medium">Data Extraction Report</span>
      <span class="font-weight-light" :title="verbs">
        {{ verbs }}
      </span>
    </div>
  </base-event-log-item>
</template>

<script>
import BaseEventLogItem from './BaseEventLogItem';
import { ReferenceEventLog, Reference } from '@/models';
import { ReferenceEvent, AssessmentState } from '@/enums';

const InternalState = {
  PROPOSED: 'PROPOSED',
  PROPOSED_WITH_CONFLICTS: 'PROPOSED_WITH_CONFLICTS',
  ACCEPTED_CONSENSUS: 'ACCEPTED_CONSENSUS',
  ACCEPTED_RESOLUTION: 'ACCEPTED_RESOLUTION',
};

const INTERNAL_STATE_TO_STYLE_PROPS = {
  [InternalState.PROPOSED]: {
    verbs: 'proposed',
    iconColor: 'primary',
  },
  [InternalState.PROPOSED_WITH_CONFLICTS]: {
    verbs: 'proposed with conflicting data',
    iconColor: 'error',
    color: 'error',
  },
  [InternalState.ACCEPTED_CONSENSUS]: {
    verbs: 'accepted due to consensus',
    iconColor: 'success',
    color: 'success',
  },
  [InternalState.ACCEPTED_RESOLUTION]: {
    verbs: 'accepted via conflict resolution',
    iconColor: 'success',
    color: 'success',
  },
};

export default {
  name: 'DataExtractionEventLogItem',
  components: { BaseEventLogItem },
  props: {
    referenceEventLog: {
      type: ReferenceEventLog,
      required: true,
    },
    reference: {
      type: Reference,
      required: true,
    },
    bottomNode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    verbs() {
      return this.styleProps.verbs;
    },
    iconColor() {
      return this.styleProps.iconColor;
    },
    color() {
      return this.styleProps.color;
    },
    styleProps() {
      return INTERNAL_STATE_TO_STYLE_PROPS[this.internalState];
    },
    internalState() {
      const { payload, event } = this.referenceEventLog;
      if (event === ReferenceEvent.DATA_EXTRACTION_REPORT_PROPOSAL) {
        return payload.dataExtractionState ===
          AssessmentState.CONFLICTED
          ? InternalState.PROPOSED_WITH_CONFLICTS
          : InternalState.PROPOSED;
      } else {
        return this.referenceEventLog.eventBy
          ? InternalState.ACCEPTED_RESOLUTION
          : InternalState.ACCEPTED_CONSENSUS;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
